import PreviewMixin from '../mixins/preview-mixin'

export default {
  mixins: [PreviewMixin],
  props: {},
  computed: {
    formatedCreateDate: function () {
      if (!this.formatData || !this.formatData.createDate) {
        return '<span class="year">&nbsp;</span>年<span class="month">&nbsp;</span>月<span class="day">&nbsp;</span>日'
      } else {
        return this.$formLib.dateFormat(this.formatData.createDate, 'yyyy年 m月 d日')
      }
    }
  }
}
